import React from "react";
import styles from "./ObjectItem.module.scss";
import {
  IProduct,
  IProjectCategory,
} from "../../../../../../../redux/reducers/ui/uiTypes";
import { store, useAppDispatch } from "../../../../../../../redux/store";
import { initSelectDataObjectAction } from "../../../../../../../redux/reducers/ui/actions/actions";
import { getProductsThunk } from "../../../../../../../redux/reducers/ui/uiThunks";
import ImageMock from "../../../../../../../assets/images/envImageMock.png";
import { changeShowModal } from "../../../../../../../redux/reducers/app/appReducer";
import { UrlService } from "../../../../../../../services/UrlService";

interface PropsI {
  project: IProjectCategory;
}
export const ObjectItem: React.FC<PropsI> = props => {
  const { project } = props;
  const dispatch = useAppDispatch();

  const handleClick = async () => {
    store.dispatch(changeShowModal({ nameModal: "loader", stateModal: true }));

    try {
      // If caller provided availableProducts (e.g., from search), prefer them
      const provided = Array.isArray(project.availableProducts)
        ? project.availableProducts
        : [];

      let product: IProduct | undefined = provided[0];

      if (!product) {
        const result = await dispatch(getProductsThunk(project.id)).unwrap();
        const studioProducts = result.rows.filter(p => p.studio);
        product = (studioProducts[0] || result.rows[0]) as IProduct | undefined;
      }

      if (!product) {
        console.error("No available products in the project");
        return;
      }

      // Wait a tick to ensure Redux state is updated.
      await new Promise(resolve => setTimeout(resolve, 0));

      dispatch(
        initSelectDataObjectAction({
          projectId: project.id,
          product,
        })
      );

      store.dispatch(
        changeShowModal({ nameModal: "loader", stateModal: false })
      );
    } catch (error: any) {
      console.error("Error fetching products:", error);
      store.dispatch(
        changeShowModal({ nameModal: "loader", stateModal: false })
      );
    }
  };
  debugger
  const imageCdnUrl = UrlService.getImageServerCdnUrl(project.imgCover ?? project.image ?? '');
  return (
    <div className={styles.item_wrapper} onClick={handleClick}>
      <div className={styles.image_wrapper}>
        <img
          src={imageCdnUrl ?? ImageMock}
          alt="object img"
        />
      </div>
      <p className={styles.title}>{project.name}</p>
    </div>
  );
};
